import { useEffect, useState } from "react";
import { fetchQuestionHeatmap } from "../services/heatmapService";

export default function useQuestionHeatmap(defaultDays = 7, bucket = "hour_of_day") {
	const [range] = useState(() => {
		const end = new Date();
		const start = new Date(end.getTime() - defaultDays * 24 * 60 * 60 * 1000);
		return { start: start.toISOString(), end: end.toISOString() };
	});
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			setLoading(true);
			setError(null);
			try {
				const res = await fetchQuestionHeatmap({ start: range.start, end: range.end, timezone: "UTC", bucket });
				if (!cancelled) setData(res);
			} catch (e) {
				if (!cancelled) setError(e?.response?.data?.message || e.message || "Failed to load heatmap");
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => { cancelled = true; };
	}, [range, bucket]);

	return { data, loading, error };
}


